module.exports = __webpack_public_path__ + "img/sent-rxnt-inactive-icon-new.0f032ba8.svg";